//Global Imports
import React, { useState, useEffect } from "react";
import clsx from "clsx";
import Countdown, { zeroPad } from "react-countdown";
//End Global Imports

//Local Imports
import Button from "../../../components/ui/Button";
import OtpBox from "../../../components/ui/OtpBox";
import { IStepTwo } from "./OtpPhase";
// import ErrorField from "../../../components/ui/ErrorField";
//End Local Imports

const OtpPhase: React.FC<IStepTwo.IProps> = ({
  otpValue,
  otpError,
  setOtpValue,
  verifyOTP,
  isOTPVerified,
  verifyOtpError = "",
  resendOTP,
  //dateKey,
  buttonText,
  title,
  rootClass,
  isLoading,
}) => {
  const [date, setDate] = useState(Date.now() + 120000);
  const [resetKey, setResetKey] = useState(0);
  const [otpLoader, setOtpLoader] = useState<boolean>(false);

  useEffect(() => {
    resetTimer();
  }, []);

  const resetTimer = () => {
    const newDate = Date.now() + 120000;
    setDate(newDate);
    setResetKey((prevKey) => prevKey + 1);
  };

  const handleResendOTP = async () => {
    setOtpLoader(true);
    try {
      resendOTP();
      resetTimer();
    } catch (error) {
      console.error(error);
    } finally {
      setOtpLoader(false);
    }
  };

  return (
    <div className={clsx(rootClass, "flex flex-col items-center")}>
      <div className="flex flex-col items-center">
        <div className={clsx(title ? "hidden" : "mb-9 text-center")}>
          <div className="mb-3 text-base font-semibold text-black font-ssp">Enter OTP</div>
          <div className="text-sm font-normal font-ssp text-grey-550">
            A 6-digit OTP is sent to your phone number.
          </div>
        </div>
        <div
          className={clsx(
            title ? "text-sm md:text-base font-semibold text-black font-ssp mb-3" : "hidden",
          )}
        >
          {title}
        </div>
        <div>
          <OtpBox
            updateValue={(value) => setOtpValue(value)}
            errorMsg={verifyOtpError}
            errorMessageClassname={otpError ? "border-none bg-[transparent] text-center" : ""}
            numberOfBoxes={6}
            otpBoxClassName="!w-[52px]"
          />
        </div>
      </div>
      {/* <div className={clsx(verifyOtpError !== "" ? "flex text-center w-full" : "hideden")}>
        <ErrorField errorMessage={verifyOtpError} />
      </div> */}
      <div
        className={clsx(
          isOTPVerified ? "flex" : "hidden",
          "text-success font-ssp font-medium text-sm mt-7",
        )}
      >
        OTP Verified
      </div>
      <div
        className={clsx(
          otpValue.length >= 1 ? "mt-[106px] sm:mt-[131px]" : "mt-[106px]",
          isOTPVerified && "mt-[72px] md:mt-[136px]",
          "flex flex-col items-center sm:justify-center justify-end h-full",
        )}
      >
        <div className={clsx("pb-8")}>
          <Countdown
            key={resetKey}
            date={date}
            renderer={({ minutes, seconds, completed }) => {
              if (completed) {
                return (
                  <Button
                    isLoading={otpLoader}
                    className="z-10 bg-transparent text-xs font-bold text-black cursor-pointer font-ssp"
                    onClickHandler={handleResendOTP}
                  >
                    Resend OTP
                  </Button>
                );
              } else {
                return (
                  <div className="flex items-center space-x-2">
                    <div className="text-xs font-bold text-black font-ssp">Resend OTP</div>
                    <div className={"text-xs font-bold text-primary font-ssp"}>
                      {zeroPad(minutes)} :{zeroPad(seconds)}
                    </div>
                  </div>
                );
              }
            }}
          />
        </div>
        <div className="flex">
          <Button
            bgColor={`${otpValue.length == 6 ? "bg-primary-1050" : "bg-grey-500"}`}
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-medium",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderWidth: "border",
              borderRadius: "rounded",
            }}
            className="w-[220px] h-[54px] z-10"
            disabled={otpValue.length < 6 || otpLoader}
            onClickHandler={verifyOTP}
            isLoading={isLoading}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OtpPhase;